import { createContext, useCallback, useContext, useState, ReactNode, useEffect } from 'react'
import { useLocation } from '@reach/router'
import {
  EscritoFormInitialValues,
  EscritosFormValues
} from 'src/components/views/EscritosLexnet/components/shared/types/escritosFormTypes'
import useEscritoMapping from 'src/contexts/EscritoContext/EscritoMapping/useEscritoMapping'
import { useLexnetStatusContext } from 'src/contexts/LexnetStatusContext'
import { TipoEscritos } from 'src/contexts/consts'
import { FormField } from 'src/enums/Form'
import { Escrito } from 'src/interfaces/EscritosLegales'

export const EscritoContext = createContext({})

export const EscritoContextProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const [isFormInitalized, setIsFormInitalized] = useState(false)
  const [initialValues, setInitialValues] = useState<null | EscritosFormValues>(null)
  const [escrito, setEscrito] = useState<null | Escrito>(null)
  const { pathname, state: locationState } = useLocation()
  const { mapping } = useEscritoMapping()
  const [send, setSend] = useState(false)
  const { lexnetUserText } = useLexnetStatusContext()

  const setData = (escrito: Escrito | null): void => {
    let escritoForm: EscritosFormValues = { ...EscritoFormInitialValues }

    setEscrito(escrito)

    if (escrito !== null) {
      escritoForm = mapping(escrito, escrito.tipoMensaje)
      // changeTipoMensaje(escrito.tipoMensaje)
    }

    escritoForm[FormField.REMITENTE_TITULAR] = lexnetUserText()
    setInitialValues(escritoForm)
  }

  const isNewEscrito = useCallback((): boolean => {
    if (!escrito) return true
    return escrito.id <= 0
  }, [escrito])

  useEffect(() => {
    setIsFormInitalized(false)

    const found = TipoEscritos.find(value => pathname.includes(value))

    setSend(false)

    if (found) {
      const { escrito } = locationState
      if (escrito) {
        setData(escrito)
      } else {
        const escritoForm: EscritosFormValues = { ...EscritoFormInitialValues }
        escritoForm[FormField.REMITENTE_TITULAR] = lexnetUserText()
        setInitialValues(escritoForm)
      }
    }
    // eslint-disable-next-line
  }, [pathname])

  // TODO - Mejorar este proceso (Ahora mismo entra dos veces en este efecto)
  useEffect(() => {
    if (escrito !== null) {
      setData(escrito)
    }
    // eslint-disable-next-line
  }, [escrito])

  return (
    <EscritoContext.Provider
      value={{
        escrito,
        initialValues,
        isFormInitalized,
        isNewEscrito,
        send,
        setData,
        setEscrito,
        setInitialValues,
        setIsFormInitalized,
        setSend
      }}
    >
      {children}
    </EscritoContext.Provider>
  )
}

export function useEscritoContext(): any {
  return useContext(EscritoContext)
}
